if (!customElements.get('stack-announcement-bar')) {
    customElements.define('stack-announcement-bar', class extends HTMLElement {
      constructor() {
        super();
        this.items = this.querySelectorAll('.announcement-item');
        if (this.items.length <= 1) return;

        this.currentIndex = 0;
        this.speed = parseInt(this.dataset.speed) || 5000;
        this.btnPrev = this.querySelector('.nav-prev');
        this.btnNext = this.querySelector('.nav-next');

        this.btnPrev.addEventListener('click', () => this.handleNav(-1));
        this.btnNext.addEventListener('click', () => this.handleNav(1));
        
        this.initAutoPlay();
      }

      handleNav(step) {
        clearInterval(this.autoplayTimer);
        this.showStep(step);
        this.initAutoPlay();
      }

      showStep(step) {
        this.items[this.currentIndex].classList.remove('is-active');
        this.currentIndex = (this.currentIndex + step + this.items.length) % this.items.length;
        this.items[this.currentIndex].classList.add('is-active');
      }

      initAutoPlay() {
        this.autoplayTimer = setInterval(() => this.showStep(1), this.speed);
      }
    });
}

if (!customElements.get('stack-shop-the-kit')) {

  class StackShopTheKit extends HTMLElement {

    connectedCallback () {
      this._carousel  = this.querySelector('.stk__carousel');
      this._cards     = Array.from(this.querySelectorAll('.stk__card'));
      this._btnPrev   = this.querySelector('.stk__nav--prev');
      this._btnNext   = this.querySelector('.stk__nav--next');
      this._dotsWrap  = this.querySelector('.stk__dots');

      if (!this._carousel || this._cards.length === 0) return;

      this._index      = 0;
      this._dragging   = false;
      this._dragStartX = 0;
      this._dragDelta  = 0;
      this._autoTimer  = null;

      this._autoplay      = this.dataset.autoplay === 'true';
      this._autoplaySpeed = parseInt(this.dataset.autoplaySpeed, 10) || 4000;

      this._buildDots();
      this._bindEvents();
      this._update();

      if (this._autoplay) this._startAutoplay();
    }

    disconnectedCallback () {
      this._stopAutoplay();
      this._unbindEvents();
    }


    _buildDots () {
      if (!this._dotsWrap) return;
      this._dotsWrap.innerHTML = '';
      this._dots = this._cards.map((_, i) => {
        const btn = document.createElement('button');
        btn.className  = 'stk__dot';
        btn.type       = 'button';
        btn.setAttribute('aria-label', `Go to slide ${i + 1}`);
        btn.addEventListener('click', () => this._goTo(i));
        this._dotsWrap.appendChild(btn);
        return btn;
      });
    }

    _bindEvents () {
      this._onPrev      = () => this._step(-1);
      this._onNext      = () => this._step(1);

      if (this._btnPrev) this._btnPrev.addEventListener('click', this._onPrev);
      if (this._btnNext) this._btnNext.addEventListener('click', this._onNext);

      this._onKeyNav = (e) => {
        if (e.key === 'ArrowLeft')  this._step(-1);
        if (e.key === 'ArrowRight') this._step(1);
      };
      this.addEventListener('keydown', this._onKeyNav);

      this._onPointerDown = this._pointerDown.bind(this);
      this._onPointerMove = this._pointerMove.bind(this);
      this._onPointerUp   = this._pointerUp.bind(this);

      this._carousel.addEventListener('pointerdown', this._onPointerDown);
      this._carousel.addEventListener('pointermove', this._onPointerMove);
      this._carousel.addEventListener('pointerup',   this._onPointerUp);
      this._carousel.addEventListener('pointercancel', this._onPointerUp);

      this._onEnter = () => this._stopAutoplay();
      this._onLeave = () => { if (this._autoplay) this._startAutoplay(); };
      this.addEventListener('mouseenter', this._onEnter);
      this.addEventListener('mouseleave', this._onLeave);
      this.addEventListener('focusin',    this._onEnter);
      this.addEventListener('focusout',   this._onLeave);
    }

    _unbindEvents () {
      if (this._btnPrev) this._btnPrev.removeEventListener('click', this._onPrev);
      if (this._btnNext) this._btnNext.removeEventListener('click', this._onNext);
      this.removeEventListener('keydown', this._onKeyNav);
      this._carousel.removeEventListener('pointerdown',  this._onPointerDown);
      this._carousel.removeEventListener('pointermove',  this._onPointerMove);
      this._carousel.removeEventListener('pointerup',    this._onPointerUp);
      this._carousel.removeEventListener('pointercancel', this._onPointerUp);
      this.removeEventListener('mouseenter', this._onEnter);
      this.removeEventListener('mouseleave', this._onLeave);
      this.removeEventListener('focusin',    this._onEnter);
      this.removeEventListener('focusout',   this._onLeave);
    }


    _pointerDown (e) {
      if (e.button !== 0 && e.pointerType === 'mouse') return;
      this._dragging   = true;
      this._dragStartX = e.clientX;
      this._dragDelta  = 0;
      this._carousel.setPointerCapture(e.pointerId);
      this._carousel.style.transition = 'none';
    }

    _pointerMove (e) {
      if (!this._dragging) return;
      this._dragDelta = e.clientX - this._dragStartX;
      const base = this._getOffset(this._index);
      this._carousel.style.transform = `translateX(${base + this._dragDelta}px)`;
    }

    _pointerUp () {
      if (!this._dragging) return;
      this._dragging = false;
      this._carousel.style.transition = '';

      const threshold = 50;
      if (this._dragDelta < -threshold) {
        this._step(1);
      } else if (this._dragDelta > threshold) {
        this._step(-1);
      } else {
        this._update(); 
      }
      this._dragDelta = 0;
    }


    _step (dir) {
      this._goTo(this._index + dir);
    }

    _goTo (i) {
      const max = this._cards.length - 1;
      this._index = Math.max(0, Math.min(i, max));
      this._update();
    }


    _getOffset (index) {
      const gap = parseFloat(
        getComputedStyle(this._carousel).getPropertyValue('--stk-card-gap') || '16'
      );

      let offset = 0;
      for (let i = 0; i < index; i++) {
        const card = this._cards[i];
        if (card) offset += card.offsetWidth + gap;
      }
      return -offset;
    }

    _update () {
      const offset = this._getOffset(this._index);
      this._carousel.style.transform = `translateX(${offset}px)`;

      if (this._dots) {
        this._dots.forEach((dot, i) => {
          dot.classList.toggle('is-active', i === this._index);
          dot.setAttribute('aria-selected', i === this._index ? 'true' : 'false');
        });
      }

      const atStart = this._index === 0;
      const atEnd   = this._index >= this._cards.length - 1;

      if (this._btnPrev) {
        this._btnPrev.classList.toggle('is-disabled', atStart);
        this._btnPrev.disabled = atStart;
      }
      if (this._btnNext) {
        this._btnNext.classList.toggle('is-disabled', atEnd);
        this._btnNext.disabled = atEnd;
      }

      this._cards.forEach((card, i) => {
        card.setAttribute('aria-hidden', i !== this._index ? 'true' : 'false');
        const link = card.querySelector('.stk__card-link');
        if (link) link.tabIndex = i !== this._index ? -1 : 0;
      });
    }


    _startAutoplay () {
      this._stopAutoplay();
      this._autoTimer = setInterval(() => {
        if (this._index >= this._cards.length - 1) {
          this._goTo(0);
        } else {
          this._step(1);
        }
      }, this._autoplaySpeed);
    }

    _stopAutoplay () {
      if (this._autoTimer) {
        clearInterval(this._autoTimer);
        this._autoTimer = null;
      }
    }

  }

  customElements.define('stack-shop-the-kit', StackShopTheKit);
}

